import { createSlice } from "@reduxjs/toolkit";
import { initialPolygonState } from "../config/config.polygonTool";

// stores polygon features created by the user
const polygonSlice = createSlice({
  name: "polygon",
  initialState: initialPolygonState,
  reducers: {
    deleteSelectedFeatures(state, action) {
      state.features.features = state.features.features.filter(
        (f, index) => !state.selectedFeatureIndexes.includes(index)
      );
      state.selectedFeatureIndexes = [];
    },
    setFeatures(state, action) {
      state.features = action.payload;
    },
    setSelectedFeatureIndexes(state, action) {
      state.selectedFeatureIndexes = action.payload;
    },
    setState(state, action) {
      state.features = action.payload.features;
      state.selectedFeatureIndexes = action.payload.selectedFeatureIndexes;
    }
  },
});

export { polygonSlice };
